<div class="info-adicional">
  <div class="info-adicional__container">

    <div class="info-adicional__grid">
      <div class="info-adicional__left">

        <div class="info-adicional__header">
          <h2 class="info-adicional__title">Información Adicional</h2>
          <p class="info-adicional__subtitle">Revisa el Contrato de Apertura y los valores vigentes de nuestros servicios</p>
        </div>
      </div>
      <div class="info-adicional__right">

        <div class="info-adicional__card">
          <div class="info-adicional__icon-container">
            <div class="info-adicional__icon-wrapper">
              <img
          src="https://www.unipay.cl/api/descargaArchivo/web-info-icono1.png"
          alt="Información Adicional Contrato"
          class="attention-channels__image"
        />
            </div>
          </div>
          <h3 class="info-adicional__card-title">Contrato Apertura Tarjeta Unipay</h3>
          <p class="info-adicional__card-description">
            <a class="info-adicional__card-link" href="https://www.unipay.cl/api/descargaArchivo/Contrato%20de%20Afiliaci%C3%B3n%20Tarjeta%20Unimarc.pdf" target="_blank">Revisa Detalles</a>
          </p>
        </div>

        <!-- Beneficio 2 -->
        <div class="info-adicional__card">
          <div class="info-adicional__icon-container">
            <div class="info-adicional__icon-wrapper">
              <img
                src="https://www.unipay.cl/api/descargaArchivo/web-info-icono2.png"
                alt="Información Adicional Pizarra"
                class="attention-channels__image"
              />
            </div>
          </div>
          <h3 class="info-adicional__card-title">Pizarra de Valores</h3>
          <p class="info-adicional__card-description">
            <a class="info-adicional__card-link" href="https://www.unipay.cl/api/descargaArchivo/Pizarra.pdf" target="_blank">Revisa Detalles</a>
          </p>
        </div>
      </div>
      <!-- Beneficio 1 -->



    </div>
  </div>
</div>
